/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect} from 'react'
import {KTSVG, useDebounce} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {useIntl} from 'react-intl'
import {getAll} from '../../../../services/common_requests'
import {useQuery} from 'react-query'

const HotelsListSearchComponent = () => {
  const intl = useIntl()
  const {updateState} = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [cityId, setCityId] = useState<string>('')
  const [ratingId, setRatingId] = useState<string>('')
  const debouncedSearchTerm = useDebounce(searchTerm, 150)

  const {data: citiesResponse} = useQuery(
    'cities-hotels-filter',
    () => getAll({size: 500}, '/cities'),
    {cacheTime: 60 * 60 * 1000, staleTime: 30 * 60 * 1000},
  )

  const {data: ratingsResponse} = useQuery(
    'ratings-hotels-filter',
    () => getAll({}, '/ratings/hotel-categories'),
    {cacheTime: 60 * 60 * 1000, staleTime: 30 * 60 * 1000},
  )

  const cities = citiesResponse?.data || []
  const ratings = ratingsResponse?.data || []

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
      updateState({
        search: debouncedSearchTerm,
        cityId: cityId || undefined,
        ratingId: ratingId || undefined,
        page: 0,
      })
    }
  }, [debouncedSearchTerm, cityId, ratingId])

  return (
    <div className='bo-filters d-flex align-items-center gap-3 flex-wrap'>
      <div className='position-relative d-flex align-items-center'>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-2 position-absolute ms-4'
        />
        <input
          type='text'
          className='form-control form-control-solid w-200px w-lg-250px ps-12'
          placeholder={intl.formatMessage({id: 'COMMON.SEARCH'})}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <select
        className='form-select form-select-solid w-auto min-w-140px'
        value={cityId}
        onChange={(e) => setCityId(e.target.value)}
      >
        <option value=''>{intl.formatMessage({id: 'COMMON.ALL_CITIES', defaultMessage: 'All cities'})}</option>
        {cities.map((city: any) => (
          <option key={city._id} value={city._id}>
            {city.name}
          </option>
        ))}
      </select>

      <select
        className='form-select form-select-solid w-auto min-w-140px'
        value={ratingId}
        onChange={(e) => setRatingId(e.target.value)}
      >
        <option value=''>{intl.formatMessage({id: 'COMMON.ALL_RATINGS', defaultMessage: 'All stars'})}</option>
        {ratings.map((rating: any) => (
          <option key={rating._id} value={rating._id}>
            {rating.label || rating.title || rating._id}
          </option>
        ))}
      </select>
    </div>
  )
}

export {HotelsListSearchComponent}
